import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SfgGeruestAuthProcessInterface, SfgGeruestStateModel } from './sfg-geruest-state.model';
import { environment } from '@work-frontend-monorepo/work-environments';
import { SfgGeruestStateSetAuthProcess, SfgGeruestStateSetHasProjects } from './sfg-geruest.actions';

@State<SfgGeruestStateModel>({
  name: environment.workStates.names.sfgGeruest || 'state__sfggeruest',
 defaults: {
    authProcess: { appAccessCode: '', emails: [], phones: [], username: '' },
    hasProjects: false,
  },
})
@Injectable()
export class SfgGeruestState {
  @Selector()
  static authProcessData(state: SfgGeruestStateModel): SfgGeruestAuthProcessInterface | null {
    return state.authProcess;
  }

  @Selector()
  static hasProjects(state: SfgGeruestStateModel): boolean {
    return state.hasProjects;
  }

  @Action(SfgGeruestStateSetAuthProcess)
  sfgGeruestStateSetAuthProcess(ctx: StateContext<SfgGeruestStateModel>, action: SfgGeruestStateSetAuthProcess) {
    ctx.patchState({ authProcess: action.authProcessData });
  }

  @Action(SfgGeruestStateSetHasProjects)
  sfgGeruestStateSetHasProjects(ctx: StateContext<SfgGeruestStateModel>, action: SfgGeruestStateSetHasProjects) {
    ctx.patchState({ hasProjects: action.hasProjects });
  }
}
